import React from 'react'
import styled from 'styled-components'

const PageEvents = ({ children }) => {
  return (
    <Wrapper>
      <Container>{children}</Container>
    </Wrapper>
  )
}

const Wrapper = styled.section`
  position: relative;
`

const Container = styled.div`
  position: relative;
  max-width: var(--max-width);
  margin: 0 auto;
  padding: var(--size-16) var(--padding-x);
`

export default PageEvents
